import React, {Component} from 'react';
import PropTypes from 'prop-types';
import ReactSlick from 'react-slick';
import './styles.css';

export default class Slider extends Component {
  static propTypes = {
    children: PropTypes.array,
    settings: PropTypes.object,
  };
  static defaultProps = {
    children: null,
    settings: null,
  };
  
  constructor(props) {
    super(props);
    this.settingsObj = {};
    if (this.props.settings === null) {
      this.settingsObj = {
        autoplay: false,
        autoplaySpeed: 3000,
        speed: 500,
        ease: 'cubic-bezier(0.215, 0.61, 0.355, 1)',
        fade: false,
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 5,
        swipe: true,
        draggable: false,
        arrows: true,
        dots: true,
        adaptiveHeight: false,
        centerMode: false,
        centerPadding: 0,
        lazyLoad: 'progressive',
        waitForAnimate: false,
        beforeChange: (old, current) => {
          this.beforeChange(old, current);
        },
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              arrows: false,
            },
          },
        ],
      }
    } else {
      if (!this.props.settings.beforeChange) {
        this.props.settings.beforeChange = (old, current) => {
          this.beforeChange(old, current);
        }
      }
      this.settingsObj = this.props.settings;
    }
    this.next = null;
    this.prev = null;
    this.currentIndex = 0;
  }
  
  render() {
    return (
      <div className="Slide" ref='slide'>
        <ReactSlick {...this.settingsObj} ref='slick'>{this.props.children}</ReactSlick>
      </div>
    );
  }
  
  componentDidMount() {
    this.next = this.refs.slide.getElementsByClassName('slick-next')[0];
    if (this.next) {
      this.next.addEventListener('animationend', () => {
        this.next.classList.remove('change');
        this.next.classList.remove('next');
      });
    }
    this.prev = this.refs.slide.getElementsByClassName('slick-prev')[0];
    if (this.prev) {
      this.prev.addEventListener('animationend', () => {
        this.prev.classList.remove('change');
        this.prev.classList.remove('prev');
      });
    }
  }
  
  //
  slickGoTo = (index, dontAnimate) => {
    this.refs.slick.slickGoTo(index, dontAnimate);
  };
  
  //
  beforeChange = (old, current) => {
    //console.log(old + ' > ' + current);
    //
    let isNext = false;
    if (current === 0) {
      if (this.currentIndex === 1) {
        isNext = false;
      } else if (this.currentIndex === this.props.children.length - 1) {
        isNext = true;
      } else {
        if (this.currentIndex < current) {
          isNext = true;
        } else {
          isNext = false;
        }
      }
    } else if (current === this.props.children.length - 1) {
      if (this.currentIndex === 0) {
        isNext = false;
      } else if (this.currentIndex === this.props.children.length - 2) {
        isNext = true;
      } else {
        if (this.currentIndex < current) {
          isNext = true;
        } else {
          isNext = false;
        }
      }
    } else {
      if (this.currentIndex < current) {
        isNext = true;
      } else {
        isNext = false;
      }
    }
    this.currentIndex = current;
    //
    if (this.next) {
      this.next.classList.remove('next');
      this.next.classList.remove('change');
      if (isNext) {
        this.next.classList.add('next');
      } else {
        this.next.classList.add('change');
      }
    }
    if (this.prev) {
      this.prev.classList.remove('prev');
      this.prev.classList.remove('change');
      if (!isNext) {
        this.prev.classList.add('prev');
      } else {
        this.prev.classList.add('change');
      }
    }
  }
  
}



// WEBPACK FOOTER //
// ./src/components/slider/index.jsx